// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../library/style/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../library/style/breakpoint.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RK6GkXTfoTIeDjzVOWMG {
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray"]};
  border-radius: 5px;
  padding: 16px;

  display: grid;
  grid-template-columns: repeat(2, 1fr);

  max-width: 750px;
  margin-bottom: 16px;
}

.RK6GkXTfoTIeDjzVOWMG p {
  margin: 8px 0;
}

.Q78qdm9MiPfhrlXj13GD {
  font-weight: 500;
}

.Nzcop6f2pYxqCsTI1bxr { width: 100% }

._3zM0TAgp0pH1EcvuX_6 {
  display: flex;
  align-items: center;
  margin-top: 8px;
  text-decoration: none;
  font-weight: 500;
}

._3zM0TAgp0pH1EcvuX_6 .lu5CrBdg2aA0mXOkyATu {
  margin-right: 4px;
}

.Gidf9fbiOQpN08YLGXmS {
  padding-bottom: 2rem;
}

@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["tablet"]}) {
  .RK6GkXTfoTIeDjzVOWMG {
    grid-template-columns: repeat(1, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Transfer/Transfer.module.css"],"names":[],"mappings":"AAOA;EACE,8DAA4B;EAC5B,kBAAkB;EAClB,aAAa;;EAEb,aAAa;EACb,qCAAqC;;EAErC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA,wBAAU,YAAY;;AAEtB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF","sourcesContent":["@value colors: \"components/library/style/colors.css\";\n@value color-purple, color-purple-bg, color-gray, color-text-subtle from colors;\n\n@value breakpoints: \"components/library/style/breakpoint.css\";\n@value desktop, laptop, tablet-l, tablet, mobile, mobile-xs from breakpoints;\n\n\n.grid {\n  border: 1px solid color-gray;\n  border-radius: 5px;\n  padding: 16px;\n\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n\n  max-width: 750px;\n  margin-bottom: 16px;\n}\n\n.grid p {\n  margin: 8px 0;\n}\n\n.text {\n  font-weight: 500;\n}\n\n.submit { width: 100% }\n\n.download {\n  display: flex;\n  align-items: center;\n  margin-top: 8px;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.download .icon {\n  margin-right: 4px;\n}\n\n.transfer {\n  padding-bottom: 2rem;\n}\n\n@media screen and (max-width: tablet) {\n  .grid {\n    grid-template-columns: repeat(1, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"components/library/style/colors.css"`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]}`,
	"color-purple-bg": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-bg"]}`,
	"color-gray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray"]}`,
	"color-text-subtle": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]}`,
	"breakpoints": `"components/library/style/breakpoint.css"`,
	"desktop": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["desktop"]}`,
	"laptop": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["laptop"]}`,
	"tablet-l": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["tablet-l"]}`,
	"tablet": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["tablet"]}`,
	"mobile": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["mobile"]}`,
	"mobile-xs": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["mobile-xs"]}`,
	"grid": `RK6GkXTfoTIeDjzVOWMG`,
	"text": `Q78qdm9MiPfhrlXj13GD`,
	"submit": `Nzcop6f2pYxqCsTI1bxr`,
	"download": `_3zM0TAgp0pH1EcvuX_6`,
	"icon": `lu5CrBdg2aA0mXOkyATu`,
	"transfer": `Gidf9fbiOQpN08YLGXmS`
};
export default ___CSS_LOADER_EXPORT___;
